"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortedSource = void 0;
var SortedSource = /** @class */ (function () {
    function SortedSource(settings) {
        this.storage = new Map();
        if (settings) {
            this.add(settings);
        }
    }
    SortedSource.prototype.select = function (key, filter) {
        var settings = this.storage.get(key);
        if (!settings) {
            return;
        }
        if (!filter) {
            return settings[0];
        }
        return settings.find(filter);
    };
    SortedSource.prototype.selectAll = function (key, filter) {
        var settings;
        if (key) {
            settings = this.storage.get(key) || [];
        }
        else {
            settings = __spreadArray([], __read(this.storage.values()), false).flat();
        }
        if (filter) {
            return settings.filter(filter);
        }
        return __spreadArray([], __read(settings), false);
    };
    SortedSource.prototype.add = function (newSettings) {
        var e_1, _a;
        if (!newSettings.length) {
            return;
        }
        var _loop_1 = function (newSetting) {
            var settings = this_1.storage.get(newSetting.key);
            if (settings) {
                var index = settings.findIndex(function (setting) { return setting.priority <= newSetting.priority; });
                if (index >= 0) {
                    settings.splice(index, 0, newSetting);
                }
                else {
                    settings.push(newSetting);
                }
            }
            else {
                this_1.storage.set(newSetting.key, [newSetting]);
            }
        };
        var this_1 = this;
        try {
            for (var newSettings_1 = __values(newSettings), newSettings_1_1 = newSettings_1.next(); !newSettings_1_1.done; newSettings_1_1 = newSettings_1.next()) {
                var newSetting = newSettings_1_1.value;
                _loop_1(newSetting);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (newSettings_1_1 && !newSettings_1_1.done && (_a = newSettings_1.return)) _a.call(newSettings_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SortedSource.prototype.removeByKeys = function (settingKeys) {
        var e_2, _a;
        try {
            for (var settingKeys_1 = __values(settingKeys), settingKeys_1_1 = settingKeys_1.next(); !settingKeys_1_1.done; settingKeys_1_1 = settingKeys_1.next()) {
                var _b = settingKeys_1_1.value, key = _b.key, priority = _b.priority;
                var settings = this.storage.get(key);
                if (!settings || !settings.length) {
                    continue;
                }
                var removeCount = 0;
                var startIndex = -1;
                for (var i = 0; i < settings.length; i++) {
                    var setting = settings[i];
                    if (setting.priority > priority) {
                        continue;
                    }
                    if (setting.priority < priority) {
                        break;
                    }
                    if (startIndex === -1) {
                        startIndex = i;
                    }
                    removeCount++;
                }
                if (startIndex !== -1) {
                    settings.splice(startIndex, removeCount);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (settingKeys_1_1 && !settingKeys_1_1.done && (_a = settingKeys_1.return)) _a.call(settingKeys_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    SortedSource.prototype.replaceAll = function (settings) {
        var prevStorage = this.storage;
        try {
            this.storage = new Map();
            this.add(settings);
        }
        catch (error) {
            this.storage = prevStorage;
            throw error;
        }
    };
    return SortedSource;
}());
exports.SortedSource = SortedSource;
//# sourceMappingURL=SortedSource.js.map